import { AreaModelAPI } from '../../../../models';
import { getAreasListAdapter } from '../../Adapters/areas/Areas.adapter';
import { requests } from '../apiAgent';

export const AreasAPI = {
    getAreas: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/areas')
            .then((response: AreaModelAPI[]) => getAreasListAdapter(response));
    },
};
